import SSocket from "servisofts-socket";
import MDLAbstract from "../MDLAbstract";
import { EventListener, Usuario } from "./types";
import { SStorage } from "servisofts-component2";
import MDL from "..";
import HTTP from "../../HTTP";
import Config from "../../Config";


export default class usuario extends MDLAbstract<EventListener> {

    session: Usuario | undefined;
    constructor() {
        super();
        this.session = undefined;
        this._loadSessionFromStorage();
    }
    async componentDidMount() {
        try {
            await this._loadSessionFromStorage();
        } catch (error) {
            console.error(error);
        }
    }
    _loadSessionFromStorage = async () => {
        const data = await SStorage.getItem("usr_log")
        if (!data) return;
        const user = JSON.parse(data);
        this.session = user;
    }

    async getAllKeys(keys: string[]) {
        const resp = await SSocket.sendPromise({
            "version": "2.0",
            "service": "usuario",
            "component": "usuario",
            "type": "getAllKeys",
            "estado": "cargando",
            "keys": keys
        })
        return resp;
    }

    async getByKey(key_usuario: string) {
        const resp: any = await SSocket.sendPromise({
            "version": "2.0",
            "service": "usuario",
            "component": "usuario",
            "type": "getByKey",
            "key": key_usuario
        })
        return resp.data;
    }

    setSession(user: Usuario) {
        this.session = user;
        this.dispatchEvent({ type: "onChangeUser", session: this.session })
        SStorage.setItem("usr_log", JSON.stringify(user));
    }

    loginChofer = async (data: { dni: string, matricula: string }) => {
        if (!data.dni) throw "El dni es requerido";
        try {
            // const response: any = await HTTP.GET({
            //     url: Config.apis.sigestran + "/chofer/" + data.dni,
            // });

            const response: any = await HTTP.GET({
                // url: Config.apis.usuario + "/usuario/loginapp/" + data.dni,
                url: Config.apis.sigestran + "/chofer/login/" + data.dni + "/" + data.matricula,
            });
            const user: Usuario = response[0];
            if (!user) {
                throw "Error"
            }
            // user.plate = data.matricula
            this.session = user;
            this.dispatchEvent({ type: "onChangeUser", session: this.session })
            SStorage.setItem("usr_log", JSON.stringify(user));
            return user;
        } catch (error: any) {
            if (error?.error == "error_password") {
                throw "Error en la contraseña"
            }
            throw error.message ?? "Error en la petición"
        }
    }


    // __loginChofer = async (data: { dni: string, matricula: string }) => {
    //     if (!data.dni) throw "El dni es requerido";
    //     try {
    //         const response: any = await MDL.checklist.getChecklistLogin({ dni: data.dni, matricula: data.matricula });

    //         if (!response) {
    //             throw "No se encontro chofer con el DNI y matricula enviados";
    //         }

    //         const tipoVehiculoId = String(response?.tipo_vehiculo_id ?? '1000').trim();

    //         const parseExpediciones = async () => {
    //             const exp = response?.expediciones;
    //             if (!exp) return [];
    //             // El backend ya devuelve expediciones parseado, pero por si acaso validamos
    //             const expediciones = Array.isArray(exp) ? exp : [];
    //             // Obtener tipo_vehiculo_id para cada expedición usando el sRemolque
    //             return Promise.all(expediciones.map(async (e) => {
    //                 try {
    //                     const infoVehiculo: any = await MDL.checklist.getChecklistTipoVehiculo(e.sRemolque);
    //                     const tipoVehiculoIdRemolque = infoVehiculo?.[0]?.tipo_vehiculo_id ?? tipoVehiculoId;
    //                     const sModelo = infoVehiculo?.[0]?.sModelo ?? '';
    //                     return {
    //                         ...e,
    //                         tipo_vehiculo_id: String(tipoVehiculoIdRemolque).trim(),
    //                         sModelo: String(sModelo).trim()
    //                     };
    //                 } catch (error) {
    //                     // Si hay error, usar el tipo_vehiculo_id del chofer
    //                     return {
    //                         ...e,
    //                         tipo_vehiculo_id: tipoVehiculoId,
    //                         sModelo: ''
    //                     };
    //                 }
    //             }));
    //         };

    //         const infoTractor: any = await MDL.checklist.getChecklistTipoVehiculo(response?.plate);

    //         const user: Usuario = {
    //             sDNI: String(response?.sDNI ?? data.dni).trim(),
    //             sNombreChofer: String(response?.sNombreChofer ?? '').trim(),
    //             plate: String(response?.plate ?? response?.sMatricula ?? data.matricula).trim(),
    //             tipo_vehiculo_id: String(infoTractor?.[0]?.tipo_vehiculo_id ?? tipoVehiculoId).trim(),
    //             sModelo: String(infoTractor?.[0]?.sModelo ?? '').trim(),
    //             expediciones: await parseExpediciones(),
    //             // Mantener otros campos si vienen en la respuesta
    //             ...(response?.iEstado !== undefined && { iEstado: response.iEstado }),
    //             ...(response?.lChofer_id && { lChofer_id: response.lChofer_id }),
    //         };

    //         console.clear();
    //         console.log("%c" + JSON.stringify(user), `color: #2ECC40; font-weight: bold;`);
    //         this.session = user;
    //         this.dispatchEvent({ type: "onChangeUser", session: this.session })
    //         SStorage.setItem("usr_log", JSON.stringify(user));
    //         return user;
    //     } catch (error: any) {
    //         throw error?.message ?? error?.detail ?? "Error al iniciar sesion"
    //     }
    // }

    login = async (usuario_: string, password: string) => {
        if (!usuario_) throw "El usuario es requerido";
        if (!password) throw "La contraseña es requerida";
        try {
            // data["password"] = CryptoJS.MD5(data["password"]).toString();
            const response: any = await SSocket.sendPromise({
                version: "2.0",
                service: "usuario",
                component: "usuario",
                type: "login",
                data: {
                    usuario: usuario_,
                    password: password
                }
            });
            const user: Usuario = response.data;
            this.session = user;
            this.dispatchEvent({ type: "onChangeUser", session: this.session })
            SStorage.setItem("usr_log", JSON.stringify(user));
            return user;
        } catch (error: any) {
            if (error?.error == "error_password") {
                throw "Error en la contraseña"
            }
            throw "Error en la petición"
        }
    }

    editar(key_usuario: string, data: Usuario) {
        return SSocket.sendPromise({
            "version": "2.0",
            "cabecera": "registro_administrador",
            "service": "usuario",
            "component": "usuario",
            "type": "editar",
            "key_usuario": key_usuario,
            "data": data
        });
    }

    registrar(data: Usuario) {
        return SSocket.sendPromise({
            "version": "2.0",
            "cabecera": "registro_administrador",
            "service": "usuario",
            "estado": "cargando",
            "component": "usuario",
            "type": "registro",
            "data": data
        });
    }

    async edit(key_usuario: string, data: Usuario) {
        try {
            const response: any = await SSocket.sendPromise({
                "version": "2.0",
                "cabecera": "registro_administrador",
                "service": "usuario",
                "component": "usuario",
                "type": "editar",
                "key_usuario": key_usuario,
                "data": data
            });
            const user: Usuario = response.data;
            this.session = user;
            this.dispatchEvent({ type: "onChangeUser", session: this.session })
            return response;
        } catch (error) {
            console.error("Error al editar usuario:", error);
            throw "Error al editar usuario";
        }
    }

    logout = async () => {
        SStorage.removeItem("usr_log");
        this.session = undefined;
        this.dispatchEvent({ type: "onChangeUser", session: this.session })
    }

    recuperarPass(correo: string) {
        return SSocket.sendPromise({
            // "version": "2.0",
            "service": "usuario",
            "component": "usuario",
            "type": "recuperarPass",
            "estado": "cargando",
            "data": correo
        });
    }

    verificarCodigoPass(codigo: string) {
        return SSocket.sendPromise({
            // "version": "2.0",
            "service": "usuario",
            "component": "usuario",
            "type": "verificarCodigoPass",
            "estado": "cargando",
            "data": codigo

        });
    }

    getByDato(ci: string) {
        return SSocket.sendPromise({
            "version": "2.0",
            "service": "usuario",
            "component": "usuario",
            "type": "getByDato",
            "estado": "cargando",
            "cabecera": "registro_administrador",
            "key_dato": "CI",
            "dato": ci
        });
    }

    cambiarPassByCodigo(password: string, usuario_recuperado: string) {
        return SSocket.sendPromise({
            // "version": "2.0",
            "service": "usuario",
            "component": "usuario",
            "type": "cambiarPassByCodigo",
            "estado": "cargando",
            "data": password,
            "usuario_recuperado": usuario_recuperado
        });
    }
}